import React, { Component } from 'react'
import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/css/image-gallery.css"

class Gallery extends Component {

    render() {
        return (
            <div>
                <h2>Galeria</h2>
                <ImageGallery items={this.props.items} />
            </div>
        );
    }

}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js